$('.wp-block-spacer').addClass('col-12')



//Block in colums
$('.block-text-boxed-colored').each(function () {
    let his_is_columns =  $(this).parents(".wp-block-columns").length
    if (his_is_columns) {
        let container = $(this).parent().parent()
        $(this).parent().parent().parent().append($(this))
        container.remove()
    }
})

//Block in colums
$('.card-instantane').each(function () {
    let his_is_columns =  $(this).parents(".wp-block-columns").length
    if (his_is_columns) {
        let container = $(this).parent().parent()
        $(this).parent().parent().parent().parent().append($(this))
        container.remove()
    }
})

//Block native table
function initGutenbergBlockTable() {
    $('.wp-block-table').each(function () {
        $(this).find('thead th').attr('scope', 'col')
        $(this).find('tbody tr td:first-child').attr('scope', 'row')
        let figcaption = $(this).find('figcaption')
        if (figcaption.length) {
            let height = figcaption.height()
            $(this).css("margin-bottom", height + 20)
            $(this).addClass('has-figcaption')
        }

        //Row color
        let number = $(this).find('tbody tr').length
        if (number%2 == 0) {
            $(this).find('tfoot tr').css('background', '#e9ebee')
        } else {
            $(this).find('tfoot tr').css('background', 'white')
        }

        //Fix overflow content
        $(this).find('figcaption').css('width', $(this).width())

        //Align
        if ($(this).hasClass('alignleft') ||
            $(this).hasClass('alignright') ||
            $(this).hasClass('aligncenter')
        ) {
            if($(this).innerWidth() > $(this).parent().width()){
                $(this).removeClass(["alignleft", "alignright", "aligncenter"])
            }
        }
    })
}


// https://dev.ocsalis.fr/ores/ressources-analyses/exemple/
initGutenbergBlockTable()
setTimeout(initGutenbergBlockTable, 100)
$(window).resize(function () {
    setTimeout(initGutenbergBlockTable, 100)
})

let external_ressource = $('.external-ressource')
if (external_ressource.length) {
    $(external_ressource).each(function(){
        if($(this).parent().parent().parent().parent().parent().hasClass("wp-block-column")){
            $(this).parent().removeClass("col-xl-6")
            $(this).parent().parent().parent().removeClass("col-xxl-8 col-xl-10 col-md-10")
            $(this).parent().addClass("col-lg-12")
            $(this).parent().parent().parent().addClass("col-lg-12")
        }
    });

}
let table = $('.wp-block-table')
if (table.length) {
    $(table).each(function(){
        if($(this).parent().parent().parent().hasClass("wp-block-column")){
            $(this).parent().removeClass("col-xxl-8 col-xl-10 col-md-10")
            $(this).parent().addClass("col-lg-12")
        }
        $(this).prepend('<div class="table-container"></div>')
        $(this).find("table").appendTo($(this).find(".table-container"));
        $(this).find("table").eq(1).remove()
    });
}
let title = $('.wp-block-heading')
if (title.length) {
    $(title).each(function(){
        if($(this).parent().parent().hasClass("wp-block-column")){
            $(this).removeClass("col-xxl-8 col-xl-10 col-md-10")
            $(this).addClass("col-lg-12")
        }
    });
}
let list_numbered  = $('.list-numbered ')
if (list_numbered.length) {
    $(list_numbered).each(function(){
        if($(this).parent().parent().parent().hasClass("wp-block-column")){
            $(this).parent().removeClass("col-xxl-8 col-xl-10 col-md-10")
            $(this).parent().addClass("col-lg-12")
        }
    });
}
let wp_block_image  = $('.wp-block-image ')
if (wp_block_image.length) {
    $(wp_block_image).each(function(){
        if($(this).parent().hasClass("wp_content")){
            $(this).addClass("col-xxl-8 col-xl-10 col-md-10 m-auto")
        }
    });
}
let wp_block_list  = $('.wp-block-list')
if (wp_block_list.length) {
    $(wp_block_list).each(function(){
        if($(this).parent().parent().hasClass("wp-block-column")){
            $(this).removeClass("col-xxl-8 col-xl-10 col-md-10 ")
            $(this).addClass("col-xxl-12 col-xl-12 col-md-12 ")
        }
    });
}
//
// let external_ressources = $('.external-ressources')
// if (external_ressources.length) {
//     if(external_ressources.parent().parent().parent().parent().parent().hasClass('wp-block-column')){
//
//         // console.log(external_ressource.parent())
//
//     }
// }
